import React from 'react';

const InfoRow = ({ label, value }) => (
  <div className="flex flex-col sm:flex-row sm:justify-between items-start sm:items-center w-full max-w-md mx-auto mb-2">
    <span className="font-medium text-sm mb-1 sm:mb-0">{label}:</span>
    <span className="text-xs text-gray-600 break-words whitespace-pre-wrap text-left sm:text-right w-full sm:max-w-[60%]">
      {value || 'N/A'}
    </span>
  </div>
);

const UserInfo = ({ data }) => {
  const user = data?.information;

  return (
    <div className="w-full px-2">
      <div className="border p-4 rounded-lg bg-[#F3F3F3] m-2 max-w-3xl mx-auto">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">User Information</h2>
        <InfoRow label="First Name" value={user?.firstName} />
        <InfoRow label="Last Name" value={user?.lastName} />
        <InfoRow label="Email" value={user?.email} />
        <InfoRow label="Date of Birth" value={user?.dob} />
        <InfoRow label="ID Number" value={user?.identificationNumber} />
        <InfoRow label="Country" value={`${user?.country?.emoji || ''} ${user?.country?.name || ''}`} />
        <InfoRow label="City" value={user?.address?.city} />
        <InfoRow label="Region" value={user?.address?.region} />
        <InfoRow label="Zip Code" value={user?.address?.zipCode} />
        <InfoRow
          label="Full Address"
          value={`${user?.address?.addressLine1 || ''} ${user?.address?.addressLine2 || ''}`}
        />
      </div>
    </div>
  );
};

export default UserInfo;
